import { Controller } from "@hotwired/stimulus";
import { clearInputs } from "../utils/stimulus_form_helper";

export default class extends Controller {

  subjects = {};
  conditions = {};

  connect() {
    const conditionElements = this.element.querySelectorAll('[data-visibility-condition]');
    const subjectElements = this.element.querySelectorAll('[data-visibility-subject-id]');
    subjectElements.forEach((element) => {
      this.subjects[element.getAttribute('data-visibility-subject-id')] = element;
    });
    conditionElements.forEach((element) => {
      const parsedCondition = JSON.parse(element.getAttribute('data-visibility-condition'));
      // For radio buttons, we have multiple elements but only want to process the checked button as the single current "value"
      if (element.type === 'radio' && !element.checked && !parsedCondition.processEmptyRadio) return;

      this.conditions[parsedCondition.id] = parsedCondition;
      this.updateVisibility(this.getConditionValue(element)?.toString(), parsedCondition.subjects);
    });
  }

  toggleVisibility(e) {
    this.updateVisibility(this.getConditionValue(e.target)?.toString(), JSON.parse(e.target.dataset.visibilityCondition).subjects);
  }

  updateVisibility(conditionValue, conditionSubjects) {
    conditionSubjects.forEach((subject) => {
      if (subject.hideOn) {
        if (subject.hideOn === conditionValue) {
          this.subjects[subject.id]?.setAttribute("hidden", true);
          this._maybeClearInputs(subject);
        } else {
          this.subjects[subject.id]?.removeAttribute("hidden");
        }
      }
      if (subject.disableOn) {
        if (subject.disableOn === conditionValue) {
          this.subjects[subject.id]?.setAttribute("disabled", true);
        } else {
          this.subjects[subject.id]?.removeAttribute("disabled");
        }
      }
      if (subject.showOn) {
        if (subject.showOn === conditionValue) {
          this._removeHiddenAttr(subject);
        } else {
          this._setHiddenAttr(subject);
        }
      } else if (subject.showOnMultiOption) {
        const showOnOptions = subject.showOnMultiOption.split(',');

        if (showOnOptions.includes(conditionValue)) {
          this._removeHiddenAttr(subject);
        } else {
          this._setHiddenAttr(subject);
        }
      }
    });
  }

  getConditionValue(condition) {
    if (condition.type === "checkbox") {
      return condition.checked;
    }
    if (condition.type === 'radio' && !condition.checked) {
      return null;
    }
    return condition.value;
  }

  _removeHiddenAttr(subject) {
    this.subjects[subject.id]?.removeAttribute("hidden");
  }

  _setHiddenAttr(subject) {
    if (this.subjects[subject.id]) {
      this.subjects[subject.id].setAttribute("hidden", true);
      this._maybeClearInputs(subject);
    }
  }

  _maybeClearInputs(subject) {
    if (subject.skipClearingInputs) return;

    clearInputs(this.subjects[subject.id]);
  }
}
